import React from "react";
import PropTypes from "prop-types";
import useListbox from "../../hooks/use-listbox";
import Listbox from "./listbox";
import ListboxSelectItem from "./listbox-select-item";
import ListboxContent from "./listbox-content";
import ListboxGroup from "./listbox-group";
import Button from "../elements/button";

var ListboxSelect = function ListboxSelect(_ref) {
  var options = _ref.options,
      onChange = _ref.onChange,
      value = _ref.value,
      emptyValue = _ref.emptyValue,
      onSearch = _ref.onSearch,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      scrollFetch = _ref.scrollFetch,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      size = _ref.size,
      icon = _ref.icon,
      buttonClassName = _ref.buttonClassName,
      hideSelectedValue = _ref.hideSelectedValue,
      headerText = _ref.headerText,
      _ref$headerClassName = _ref.headerClassName,
      headerClassName = _ref$headerClassName === void 0 ? "" : _ref$headerClassName,
      children = _ref.children;

  var _useListbox = useListbox(options, onSearch, onClose, scrollFetch),
      filteredOptions = _useListbox.filteredOptions,
      flattenedOptions = _useListbox.flattenedOptions,
      handleSearch = _useListbox.handleSearch,
      handleClose = _useListbox.handleClose,
      filteredCount = _useListbox.filteredCount,
      isGrouped = _useListbox.isGrouped,
      isSearchable = _useListbox.isSearchable;

  var selectedOption = value && (value.label ? value : flattenedOptions.find(function (option) {
    return option.value === value.value;
  }));
  var displayValue = selectedOption ? selectedOption.label : "";
  var labelAndValue = selectedOption ? "".concat(label, ". ").concat(displayValue, " selected") : "".concat(label, ". No option selected");
  return /*#__PURE__*/React.createElement(Listbox, {
    ariaLabel: labelAndValue,
    emptyValue: emptyValue,
    value: displayValue,
    size: size,
    disabled: disabled,
    onClose: handleClose,
    icon: icon,
    buttonClassName: buttonClassName,
    hideSelectedValue: hideSelectedValue
  }, function (_ref2) {
    var closePopover = _ref2.closePopover;
    return /*#__PURE__*/React.createElement(React.Fragment, null, headerText && /*#__PURE__*/React.createElement("p", {
      className: "listbox-select--header ".concat(headerClassName)
    }, headerText), /*#__PURE__*/React.createElement(ListboxContent, {
      searchable: isSearchable,
      filteredCount: filteredCount,
      handleSearch: handleSearch,
      scrollFetch: scrollFetch,
      loading: loading
    }, filteredOptions.map(function (option) {
      return isGrouped ? /*#__PURE__*/React.createElement(ListboxGroup, {
        key: option.label,
        label: option.label,
        showLabel: option.items.length > 0
      }, option.items.map(function (option) {
        return /*#__PURE__*/React.createElement(ListboxSelectItem, {
          key: option.value,
          onClick: onChange,
          item: option,
          selectedValue: value,
          closePopover: closePopover
        });
      })) : /*#__PURE__*/React.createElement(ListboxSelectItem, {
        key: option.value,
        onClick: onChange,
        item: option,
        selectedValue: value,
        closePopover: closePopover
      });
    }), children));
  });
};

var optionsFormat = PropTypes.arrayOf(PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  icon: PropTypes.string,
  disabled: PropTypes.bool
}));
var groupedOptionsFormat = PropTypes.arrayOf(PropTypes.shape({
  label: PropTypes.string.isRequired,
  items: optionsFormat.isRequired
}));
ListboxSelect.propTypes = {
  options: PropTypes.oneOfType([optionsFormat, groupedOptionsFormat]).isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,

  /**
   * You can pass an emptyValue if you want to display something other than the default "Select..."
   */
  emptyValue: PropTypes.string,
  onSearch: PropTypes.func,
  onClose: PropTypes.func,
  scrollFetch: PropTypes.func,
  loading: PropTypes.bool,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  icon: PropTypes.string,
  buttonClassName: PropTypes.string,
  hideSelectedValue: PropTypes.bool,
  headerText: PropTypes.string,
  headerClassName: PropTypes.string,
  children: PropTypes.object
};
export default ListboxSelect;